import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/authContext';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function LegalEntityManagement() {
  const authCtx = useContext(AuthContext);

  if (!authCtx.checkRight('legalEntity:read')) {
    return <Navigate to='/welcome' replace />;
  }

  const legalEntitySchema = {
    legalName: {
      label: 'Rechtlicher Name',
      type: 'text',
      required: true,
      minWidth: '240px',
    },
    unitName: {
      label: 'Firmenzusatz',
      type: 'text',
      required: true,
      minWidth: '200px',
    },
    street: {
      label: 'Straße und Hausnummer',
      type: 'text',
      required: true,
      minWidth: '260px',
    },
    postcode: {
      label: 'PLZ',
      type: 'text',
      required: true,
      minWidth: '100px',
    },
    city: {
      label: 'Ort',
      type: 'text',
      required: true,
      minWidth: '180px',
    },
    hrNumber: {
      label: 'HR-Nummer',
      type: 'text',
      required: true,
      minWidth: '160px',
    },
    hrLocation: {
      label: 'HR-Ort',
      type: 'text',
      required: true,
      minWidth: '160px',
    },
    ustID: {
      label: 'USt-IdNr.',
      type: 'text',
      required: true,
      minWidth: '160px',
    },
    directors: {
      label: 'Geschäftsführer',
      type: 'text',
      required: true,
      minWidth: '260px',
      previewInList: true,
      previewMaxLines: 2,
    },
    iban: {
      label: 'IBAN',
      type: 'text',
      required: true,
      minWidth: '220px',
    },
    bic: {
      label: 'BIC',
      type: 'text',
      required: true,
      minWidth: '160px',
    },
    imprintUrl: {
      label: 'Impressum URL',
      type: 'text',
      required: false,
      minWidth: '260px',
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      schema={legalEntitySchema}
      title='Neuen Rechtsträger anlegen'
      resourceType='legalEntity'
      headerSearchPlaceholder='Rechtliche Einheiten durchsuchen'
      parentIsEditable={authCtx.checkRight('legalEntity:update')}
      options={{ titleKey: 'legalName' }}
      visibleColumnKeys={['legalName', 'unitName', 'street', 'postcode', 'city']}
    />
    </Box>
  );
}

export default LegalEntityManagement;
